/**
 * Money for the landing cart.
 *
 * The cart holds integer cents end to end, because that is what the API sends
 * and because floats do not add up — accumulating a cart as decimals is how
 * you end up showing a customer 26.990000000000002. Cents become dinars
 * exactly once, here, on the way to the screen.
 */

/** Currency suffix as a customer reads it. */
export const CURRENCY = "DA";

/**
 * Cents to whole dinars.
 *
 * The Algerian dinar is not quoted in subunits on this site — every seeded
 * price is a whole number and no price here should ever show a decimal point.
 * A stray 1250 still has to land somewhere, so it is rounded rather than
 * truncated, and an exact half is settled AGAINST the shop: `Math.round`
 * breaks .5 upward, which would quietly bill the customer an extra dinar,
 * while negating both ends breaks it downward instead.
 */
export function toDinars(cents: number): number {
  return -Math.round(-cents / 100);
}

/** A price as a customer reads it, e.g. "450 DA". Never has a decimal point. */
export function formatMoney(cents: number, currency: string = CURRENCY): string {
  return `${toDinars(cents)} ${currency}`;
}
